import React from 'react';
import PropTypes from 'prop-types';

const VideoPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M2 8.994A2.998 2.998 0 0 1 5.008 6h21.984A3.003 3.003 0 0 1 30 8.994v14.012A2.999 2.999 0 0 1 26.992 26H5.008A3.003 3.003 0 0 1 2 23.006V8.994zm10 2.576c0-.551.389-.73.863-.4l6.794 4.705c.477.33.452.836-.048 1.125l-6.698 3.866c-.502.29-.911.075-.911-.472V11.57z"
    />
  );
};

VideoPath.propTypes = {
  fill: PropTypes.string,
};

export default VideoPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/video.jsx